<template>
  <section :class="['winners', totalWinners === 0 ? 'no_winners_at_all' : showTestimonials ? 'wloggedout' : '']">
    <div class="winners__header_testi" v-if="showTestimonials" >
      <div class="winners__header__testimonials">
        <div class="testimonials__carousel">
          <div class="testimonials-carousel generic-carousel">
            <div class="item" v-for="(item,index) in 7" :key="index" v-if="getTranslationTestimonial(index,'visitor_winners_testimonial')" style="cursor: pointer">
              <img :src="getTranslationTestimonial(index,'visitor_winners_testimonial_img')" alt="">
              <span>{{ getTranslationTestimonial(index,'visitor_winners_testimonial') }}<br/>{{ getTranslationTestimonial(index,'visitor_winners_testimonial_prize') }}</span>
            </div>
          </div>
        </div>
        <div class="carousel__nav"></div>
      </div>
    </div>
    <div class="winners__header" v-else>
      <div class="winners__header__content">
        <img v-if="totalWinners" src="static/images/icon-winners.png"/>
        <img v-else src="static/images/icon-no-winners.png"/>
      </div>
    </div>
    <div class="winners__heading">
      <h1>{{ getTranslations.visitor_visitor_header_winners }}</h1>
    </div>
    <div class="winners__table">

      <p class="winners__table__winners_total">{{ totalWinners }} {{ getTranslations.winners_page_winners_so_far }}</p>
      <p class="winners__table__announcement">{{ getTranslations.winners_page_more_winners }}</p>

      <!-- MEMORY WIZARD LIST -->
      <h1 class="winners__table__game_header">
        <img src="static/images/logo-memory-wizard.png">
        <br/>
        <span>{{ getTranslations.winners_page_memory_wizard }}</span>
      </h1>
      <ul :class="['winners__table__game_list', memoryWizardWinners.length < 1 ? 'no_winners_for_game' : '']">
        <li class="winners__table__game_list_item" v-for="(winner, index) in memoryWizardWinners" :key="index">
          <span>{{ winner.totalWinners }} {{ getTranslations.winners_page_winners_of_prize }} {{ winner.prizeName }}</span>
          <img :src="winner.imageUrl" />
        </li>
      </ul>
      <h1 v-show="!moreWinnersButton" class="winners__table__game_header">
        <img src="static/images/logo-odd-object.png">
        <br/>
        <span>{{ getTranslations.winners_page_odd_object }}</span>
      </h1>
      <ul :class="['winners__table__game_list', oddObjectWinners.length < 1 ? 'no_winners_for_game' : '']">
        <li class="winners__table__game_list_item" v-for="(winner, index) in oddObjectWinners" :key="index">
          <span>{{ winner.totalWinners }} {{ getTranslations.winners_page_winners_of_prize }} {{ winner.prizeName }}</span>
          <img :src="winner.imageUrl" />
        </li>
      </ul>
      <!-- ODD OBJECT LIST END -->

      <!-- SPOT THE DIFFERENCE LIST -->
      <h1 v-show="!moreWinnersButton" class="winners__table__game_header">
        <img src="static/images/logo-spot-difference.png">
        <br/>
        <span>{{ getTranslations.winners_page_spot_the_diff }}</span>
      </h1>
      <ul :class="['winners__table__game_list', spotDifferenceWinners.length < 1 ? 'no_winners_for_game' : '']">
        <li class="winners__table__game_list_item" v-for="(winner, index) in spotDifferenceWinners" :key="index">
          <span>{{ winner.totalWinners }} {{ getTranslations.winners_page_winners_of_prize }} {{ winner.prizeName }}</span>
          <img :src="winner.imageUrl" />
        </li>
      </ul>
      <!-- SPOT THE DIFFERENCE LIST END -->
      <input v-show="moreWinnersButton" type="submit" value="···" style="cursor: pointer"
             :class="['load-more btn2 btn2--std btn2--small btn2--green ', (totalWinners === 0) ? ' winners_empty' : '']"
             @click.prevent="displayMore">
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Vue from 'vue';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'winners',
  data() {
    return {
      countTestimonials: 0,
      showTestimonials: false,
    };
  },
  mounted() {
    for (let i = 0; i <= 6;) { // copy from Movie Lines
      if (this.getTranslationTestimonial(i, 'visitor_winners_testimonial')) {
        this.showTestimonials = true;
        this.countTestimonials += 1;
      }
      i += 1;
    }
    this.$nextTick(() => {
      /* eslint-disable */
      // default home page carousel
      $('.testimonials-carousel').owlCarousel({
        loop: this.countTestimonials > 1,
        responsiveClass: true,
        margin: 10,
        dots: true,
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        navContainer: this.countTestimonials > 1 ? '.carousel__nav' : '',
        navText: ['<i class="icon-arrow-left"></i>','<i class="icon-arrow-right"></i>'],
        responsive: {
          0: {
            items: 1,
            nav: true,
          },
        },
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    /* eslint-disable */
    console.log('==> inside component\'s beforeRouteLeave: Winners');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    this.storeVisitorWinners(this.getLocale);
    next();
    /* eslint-enable */
  },
  methods: {
    ...mapActions('profile', [
      'storeVisitorWinners',
    ]),
    ...mapMutations('profile', [
      'setMoreWinnersButton',
    ]),
    displayMore() {
      this.setMoreWinnersButton(false);
    },
  },
  computed: {
    ...mapState('profile', [
      'moreWinnersButton',
      'totalWinners',
      'oddObjectWinners',
      'spotDifferenceWinners',
      'memoryWizardWinners',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationTestimonial',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Winners.vue